export const removeLandingScreen = () => {
  const landingScreen = document.getElementById('progress-logo-screen')
  if (landingScreen === null) { return }
  landingScreen.remove()
}

export default removeLandingScreen
